namespace app.support.alert {

    import IDialogService = ng.material.IDialogService;
    import AlertService = app.support.alert.AlertService;

    interface IGrupoAlerta {
        titulo: string;
        mensagem: string;
        alertas: Array<{ identificador: string, descricao: string, data: Date, observacao: string }>;
    }
        
    export class AlertController {

        public gruposAlertas: Array<IGrupoAlerta> = [];
        
        /** @ngInject **/
        public constructor(private $mdDialog: IDialogService,            
                private alertService: AlertService,
                private alertas: Array<IAlert>) {
            this.gruposAlertas = this.incluirGruposAlertas(alertas);                
        }        

        public definirCiencia(grupoAlertas: Array<IGrupoAlerta>): void {
            const identicadores = [];
            grupoAlertas.forEach(grupo => {
                grupo.alertas.map(alerta => identicadores.push(alerta.identificador));
            }); 

            this.alertService.atualizarAlertasComoLidos(identicadores);

            this.gruposAlertas = [];

            this.$mdDialog.hide();
        }

        public mostrarIdentificacao(alerta: string): string {
            return JSON.parse(alerta).informacao;
        }

        private incluirGruposAlertas(alertas: Array<IAlert>): Array<IGrupoAlerta> {
            const agrupado = alertas.reduce((agrupador, alerta) => {
                const { titulo, mensagem, informacao, observacao } = JSON.parse(alerta.content.toString());
        
                if (!agrupador[alerta.name]) {
                    agrupador[alerta.name] = {
                        titulo,
                        mensagem,
                        alertas: []
                    };
                }
        
                agrupador[alerta.name].alertas.push(
                    {
                        identificador: alerta.identificador, 
                        descricao: informacao.toString(),
                        data: alerta.creationDate,
                        observacao: observacao
                    });
        
                return agrupador;
            }, {} as { [key: string]: IGrupoAlerta });        
            
            const resultado = (function() {
                const values = [];
                for (const chave in agrupado) {
                    if (agrupado.hasOwnProperty(chave)) {
                        values.push(agrupado[chave]);
                    }
                }
                return values;
            })();

            return resultado;
        }
        
    }
    
    angular
        .module("app.support.alert")
        .controller("app.support.alert.AlertController", AlertController);
}
